// src/components/AdPlaceholder.js
import React from 'react';

/**
 * Componente placeholder para anúncios
 * Aguardando aprovação do sistema de anúncios
 * 
 * Props:
 * - position: 'sidebar' | 'banner' | 'footer' | 'medium'
 * - size: override manual de tamanho (opcional)
 */
const AdPlaceholder = ({ position = 'sidebar', size = null }) => {
  // Tamanhos padrão por posição
  const sizeMap = {
    sidebar: { width: 'w-48', height: 'h-96', label: '300x600' },
    banner: { width: 'w-full', height: 'h-24', label: '728x90' },
    footer: { width: 'w-full', height: 'h-32', label: '728x250' },
    medium: { width: 'w-48', height: 'h-64', label: '300x400' }
  };

  const dimensions = sizeMap[position] || sizeMap.sidebar;

  return (
    <div 
      className={`${dimensions.width} ${dimensions.height} bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center p-4`}
      role="img"
      aria-label={`Espaço publicitário ${dimensions.label}`}
    >
      <div className="text-center">
        <div className="text-gray-400 text-xs font-semibold mb-2">PUBLICIDADE</div>
        <div className="text-gray-300 text-xs">{dimensions.label}</div>
      </div>
    </div>
  );
};

export default AdPlaceholder;

